import { useState } from 'react';
import useClient from 'api/client';
import createSqlPipeline from 'api/SqlPipeline/createSqlPipeline';
import { NewSqlPipelineInput } from 'types/Pipeline';
import { useAlert } from 'components/message/AlertContext';

export default function useCreatePipeline() {
    const client = useClient();
    const { openAlert } = useAlert();

    const [buttonLoading, setButtonLoading] = useState(false);

    const handleSubmit = async (pipeline: NewSqlPipelineInput) => {
        setButtonLoading(true);
        try {
            const response = await client.mutate(createSqlPipeline(pipeline));

            if (!response.errors) {
                return response.data.createSqlPipeline;
            } else {
                openAlert({
                    message: response.errors[0]?.message,
                    title: 'Error',
                    severity: 'alert',
                });
                return null;
            }
        } finally {
            setButtonLoading(false);
        }
    };

    return { buttonLoading, handleSubmit };
}
